import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ICourse } from "../../../Pages/Subject/ICourse";

export const AddCourseSlice = createSlice({
  name: "AddCourseSlice",
  initialState: {} as IReduxState<ICourse>,
  reducers: {
    addCourse: (state, _: PayloadAction<ICourse>) => {
      state.isLoading = true;
    },
    successaddCourse: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddCourse: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddCourseResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  addCourse,
  failureaddCourse,
  successaddCourse,
  clearAddCourseResponse,
} = AddCourseSlice.actions;

export default AddCourseSlice.reducer;
